const HOST = `https://3d-api.radivas-remont.ru`;
const CONSTRUCTOR = `https://3d.radivas-remont.ru`;

export {
  HOST, CONSTRUCTOR
};
